(function () {
  'use strict';

  if (window.__arcaverseProductGalleryRulesV1) return;
  window.__arcaverseProductGalleryRulesV1 = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/compatible/g, '')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  function debugLog() {
    if (!window.ArcaverseDebugGallery || !window.console || !window.console.log) return;
    window.console.log.apply(window.console, arguments);
  }

  function debugWarn() {
    if (!window.ArcaverseDebugGallery || !window.console || !window.console.warn) return;
    window.console.warn.apply(window.console, arguments);
  }

  function parseJsonElement(element, fallback) {
    if (!element) return fallback;

    try {
      var raw = String(element.textContent || '').trim();
      if (!raw) return fallback;

      var parsed = JSON.parse(raw);

      if (typeof parsed === 'string') {
        try {
          parsed = JSON.parse(parsed);
        } catch (innerError) {
          return fallback;
        }
      }

      return parsed || fallback;
    } catch (error) {
      debugWarn('ArcaVerse media rules JSON failed:', error);
      return fallback;
    }
  }

  function parseTaggedAlt(rawAlt) {
    var raw = String(rawAlt || '').trim();
    var pipeIndex = raw.indexOf('|');

    if (pipeIndex === -1) {
      return {
        keys: [],
        cleanAlt: raw
      };
    }

    var keyPart = raw.slice(0, pipeIndex).trim();
    var cleanAlt = raw.slice(pipeIndex + 1).trim();

    var keys = keyPart
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);

    return {
      keys: keys,
      cleanAlt: cleanAlt || raw
    };
  }

  function getSectionIdFromRoot(root) {
    return String(root.id || '').replace('av-product-hero-', '');
  }

  function getOptionMap(root) {
    var optionMap = {};

    Array.prototype.slice.call(root.querySelectorAll('.av-product-option-select')).forEach(function (select) {
      var name = String(select.getAttribute('data-option-name') || '').trim();
      if (!name) return;
      optionMap[normalize(name)] = String(select.value || '').trim();
    });

    return optionMap;
  }

  function getSelectedOptionValues(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.av-product-option-select'))
      .map(function (select) {
        return String(select.value || '').trim();
      });
  }

  function findSelectedVariant(root, variants) {
    if (!Array.isArray(variants) || !variants.length) return null;

    var selectedOptions = getSelectedOptionValues(root);
    if (!selectedOptions.length) return null;

    return variants.find(function (variant) {
      if (!variant || !Array.isArray(variant.options)) return false;
      if (variant.options.length !== selectedOptions.length) return false;

      for (var i = 0; i < selectedOptions.length; i++) {
        if (String(variant.options[i] || '').trim() !== selectedOptions[i]) {
          return false;
        }
      }

      return true;
    }) || null;
  }

  function getSelectedVariantMediaGroup(root, variants) {
    var variant = findSelectedVariant(root, variants);
    if (!variant) return '';

    return String(variant.mediaGroup || '').trim();
  }

  function matchesRule(rule, optionMap) {
    if (!rule || !rule.when || typeof rule.when !== 'object') return false;

    var keys = Object.keys(rule.when);
    if (!keys.length) return false;

    for (var i = 0; i < keys.length; i++) {
      var optionName = keys[i];
      var selectedValue = optionMap[normalize(optionName)];

      if (typeof selectedValue === 'undefined') {
        return false;
      }

      var allowedValues = Array.isArray(rule.when[optionName])
        ? rule.when[optionName]
        : [rule.when[optionName]];

      var selectedNormalized = normalize(selectedValue);
      var allowedMatch = allowedValues.some(function (allowedValue) {
        return normalize(allowedValue) === selectedNormalized;
      });

      if (!allowedMatch) {
        return false;
      }
    }

    return true;
  }

  function getProductRulesGalleryKey(root, rules) {
    if (!rules || typeof rules !== 'object') return '';

    var optionMap = getOptionMap(root);
    var ruleList = Array.isArray(rules.rules) ? rules.rules : [];

    for (var i = 0; i < ruleList.length; i++) {
      if (matchesRule(ruleList[i], optionMap)) {
        return String(ruleList[i].gallery || '').trim();
      }
    }

    return String(rules.default || '').trim();
  }

  function getActiveGalleryKey(root, rules, variants) {
    return getSelectedVariantMediaGroup(root, variants) || getProductRulesGalleryKey(root, rules);
  }

  function getThumbButtons(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.av-product-hero__thumb[data-av-media-id]'));
  }

  function prepareThumbs(root) {
    getThumbButtons(root).forEach(function (button) {
      if (button.dataset.avGalleryPrepared === 'true') return;

      var img = button.querySelector('img');
      var rawAlt = img ? img.getAttribute('alt') : '';
      var parsed = parseTaggedAlt(rawAlt);

      button.dataset.avGalleryKeys = parsed.keys.join(',');
      button.dataset.avCleanAlt = parsed.cleanAlt;
      button.dataset.avGalleryPrepared = 'true';

      if (img && parsed.cleanAlt) {
        img.setAttribute('alt', parsed.cleanAlt);
      }
    });
  }

  function buttonMatchesGallery(button, galleryKey) {
    if (!galleryKey) return true;

    var keys = String(button.dataset.avGalleryKeys || '')
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);

    if (!keys.length) return false;

    return keys.indexOf(galleryKey) !== -1 || keys.indexOf('shared') !== -1 || keys.indexOf('all') !== -1;
  }

  function cleanMainMediaAlt(root) {
    var main = root.querySelector('.av-product-hero__main-media');
    if (!main) return;

    Array.prototype.slice.call(main.querySelectorAll('img')).forEach(function (img) {
      var parsed = parseTaggedAlt(img.getAttribute('alt') || '');
      if (parsed.cleanAlt) {
        img.setAttribute('alt', parsed.cleanAlt);
      }
    });
  }

  function showFullGallery(root) {
    var buttons = getThumbButtons(root);

    buttons.forEach(function (button) {
      button.hidden = false;
      button.classList.remove('av-gallery-is-hidden');
    });

    var activeButton = buttons.find(function (button) {
      return button.classList.contains('is-active');
    });

    if (!activeButton && buttons.length) {
      buttons[0].click();
    }

    cleanMainMediaAlt(root);
  }

  function applyGallery(root, rules, variants) {
    prepareThumbs(root);

    var galleryKey = getActiveGalleryKey(root, rules, variants);
    var buttons = getThumbButtons(root);

    if (!buttons.length) return;

    if (!galleryKey) {
      showFullGallery(root);
      return;
    }

    var matchingButtons = buttons.filter(function (button) {
      return buttonMatchesGallery(button, galleryKey);
    });

    if (!matchingButtons.length) {
      debugWarn('ArcaVerse gallery rules: no media found for gallery key, showing full gallery:', galleryKey);
      showFullGallery(root);
      return;
    }

    buttons.forEach(function (button) {
      var shouldShow = matchingButtons.indexOf(button) !== -1;
      button.hidden = !shouldShow;
      button.classList.toggle('av-gallery-is-hidden', !shouldShow);
    });

    var activeButton = buttons.find(function (button) {
      return button.classList.contains('is-active');
    });

    if (!activeButton || activeButton.hidden) {
      matchingButtons[0].click();
    }

    window.setTimeout(function () {
      cleanMainMediaAlt(root);
    }, 0);
  }

  ready(function () {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[id^="av-product-hero-"]'));

    roots.forEach(function (root) {
      var sectionId = getSectionIdFromRoot(root);
      var rulesElement = document.getElementById('av-media-rules-json-' + sectionId);
      var variantsElement = document.getElementById('av-variants-json-' + sectionId);
      var rules = parseJsonElement(rulesElement, {});
      var variants = parseJsonElement(variantsElement, []);
      var hasRules = rules && (rules.default || Array.isArray(rules.rules));
      var hasVariants = Array.isArray(variants) && variants.length;

      if (!hasRules && !hasVariants) {
        prepareThumbs(root);
        cleanMainMediaAlt(root);
        return;
      }

      debugLog('ArcaVerse gallery rules applying:', rules, variants);
      applyGallery(root, rules, variants);

      root.addEventListener('change', function (event) {
        if (!event.target || !event.target.classList || !event.target.classList.contains('av-product-option-select')) {
          return;
        }

        window.setTimeout(function () {
          applyGallery(root, rules, variants);
        }, 0);
      });

      root.addEventListener('click', function () {
        window.setTimeout(function () {
          cleanMainMediaAlt(root);
        }, 0);
      });
    });
  });
})();
